import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_INFERNO } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/hollah.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Hollah! — Disfigure (NCS). 145 BPM bouncy drumstep with tight
 * syncopation and a snappy snare. Hard-tier challenge — the offbeat
 * accents push the snake-pattern lane assignment into busier shapes.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const HOLLAH_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'hollah',
  baseTitle: 'Hollah!',
  description:
    "Disfigure's bouncy 145 BPM drumstep. Tight syncopation pushes the lanes into busy chord-accented patterns.",
  difficulty: 4,
  totalBeats: 148,
  palette: PALETTE_INFERNO,
  audio: buildBuiltinAudio({
    src: '/audio/circles/hollah.mp3',
    attribution: '"Hollah!" by Disfigure [NCS Release] - https://ncs.io/Hollah',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 148,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.06, minSpacing: 0.5 },
    },
  ],
});
